const BilledStatus = {
  Billed: "billed",
  Paid: "paid",
};

export default BilledStatus;
